export default __webpack_public_path__ + "static/media/Mary 9781408342749.5641035f.jpg";